import store from '@/store';
import {requireModule} from '@/routes/guards';

const GalleryIndex = () => import(/* webpackChunkName: "gallery-module" */ '@views/gallery/views/GalleryIndex.vue');
const GalleryFolder = () => import(/* webpackChunkName: "gallery-module" */ '@views/gallery/folder/GalleryFolder.vue');
const GalleryChildProfileFolder = () => import(/* webpackChunkName: "gallery-module" */ '@views/gallery/folder/GalleryChildProfileFolder.vue');
const GalleryDiaryIndex = () => import(/* webpackChunkName: "gallery-module" */ '@views/gallery/views/GalleryDiaryIndex.vue');
const GalleryDiaryFolder = () => import(/* webpackChunkName: "gallery-module" */ '@views/gallery/views/GalleryDiaryFolder.vue');

export default [
    {
        path: '/gallery',
        name: 'gallery.index',
        components: {base: GalleryIndex},
        beforeEnter: requireModule('galleries', (to, from, next) => {
            if (store.getters.canAccessGalleryIndex) {
                next();
            } else {
                next({path: '/access-restricted'});
            }
        })
    },
    {
        // Child-profile files are their own module, not part of Galleries.
        path: '/gallery/child-profile/:child_id?',
        name: 'gallery.builtin.child-profile',
        components: {base: GalleryChildProfileFolder},
        beforeEnter: requireModule('child_profile_files', (to, from, next) => {
            const canAccessBuiltin =
                store.getters.canAccessChildFilesEmployee ||
                store.getters.canAccessChildFilesGuardian;
            if (store.getters.canAccessGalleryIndex && canAccessBuiltin) {
                next();
            } else {
                next({path: '/access-restricted'});
            }
        })
    },
    {
        path: '/gallery/diary',
        name: 'gallery.builtin.diary.index',
        components: {base: GalleryDiaryIndex},
        beforeEnter: requireModule('diaries', (to, from, next) => {
            if (store.getters.canAccessGalleryIndex) {
                next();
            } else {
                next({path: '/access-restricted'});
            }
        })
    },
    {
        path: '/gallery/diary/:course_id',
        name: 'gallery.builtin.diary',
        components: {base: GalleryDiaryFolder},
        beforeEnter: requireModule('diaries', (to, from, next) => {
            if (store.getters.canAccessGalleryIndex) {
                next();
            } else {
                next({path: '/access-restricted'});
            }
        })
    },
    {
        path: '/gallery/:folder',
        name: 'gallery.folder',
        components: {base: GalleryFolder},
        beforeEnter: requireModule('galleries', (to, from, next) => {
            if (store.getters.canAccessGalleryIndex) {
                next();
            } else {
                next({path: '/access-restricted'});
            }
        })
    }
];


